
import { Grid } from "@material-ui/core";
import useErmaStyling from "../../hooks/useErmaStyling"

const ErmaResponsiveGridItem = (props) =>{
  const styling = useErmaStyling();

  /**
   * 
   */
  const validateProps = () => {
    let validProps = "";
    validProps += props?.xs ? "" : " xs ";
    validProps += props?.sm ? "" : " sm ";
    validProps += props?.element ? "" : " element ";
    
    if (props?.classes) {
      validProps += props.classes?.xs ? "" : " classes.xs ";
      validProps += props.classes?.xs ? "" : " classes.sm ";
    }

    if (validProps.length > 0) {
      throw new Error("Invalid Properties passed to ErmaResponsiveGridItem. Missing " + validProps)
    }
  }

  /**
   * 
   */
  const calculateStyling = () => {
    let labelStyles = [styling.ermaStyles.gridTable_labelField];
    let valueStyles = [];

    if (styling.isMobile && props.classes?.xs) {
      labelStyles.push(props.classes.xs);
      valueStyles.push(props.classes.xs);
    } else if (props.classes?.sm) {
      labelStyles.push(props.classes.sm);
      valueStyles.push(props.classes.sm);
    }
    
    return {label: labelStyles.join(" "), value: valueStyles.join(" ")};
  }

  /**
   * 
   * @returns 
   */
  const render = () => {
    let styles = calculateStyling();
    
    let elementJsx = props.element(props.record, props.label, styling.isMobile)

    if (!styling.isMobile) {
      return (
        <Grid item sm={props.sm} className={styles.value}>
          { elementJsx }
        </Grid>
      );
    }

    return (
      <>
        { <Grid container xs={props.xs} direction="column">
            <Grid item className={styles.label}>
              { !props?.noXsLabel && props.label }
            </Grid>
            <Grid item className={styles.value}>
              { elementJsx }
            </Grid>
          </Grid>
        }
        
      </>
    )
  }

  validateProps();

  return render();
}

export default ErmaResponsiveGridItem;